// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__35wN0","isChecked":"Card_isChecked__OTBjS"};